import { EuiAvatar, EuiBadge, EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiListGroupItem, EuiPopover, EuiText } from '@elastic/eui';
import React, { useEffect, useState, useMemo} from 'react';
import { TiposAdjuntoList } from '../../../components/Listas/TiposAdjunto';
import { TIPOINIT, TIPOSADJUNTO } from '../../../components/Listas/TiposAdjunto/constants';
import { toDecimalString } from '../../../../../shared/utils/numbers';

export const ItemAdjuntoList = (props) =>{

    const {item, extraAction, changeType, onDonwLoad} = props;

    const [tipoAdjunto, setTipoAdjunto] = useState(item.tipo!==undefined? item.tipo : TIPOINIT);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    useEffect(()=>{
        if(tipoAdjunto!==undefined)
        {
            if(item.tipo===undefined || (item.tipo.idTipoAdjunto!==tipoAdjunto.idTipoAdjunto))
            changeType && changeType({...item,...{tipo:tipoAdjunto}})
        }
    },[tipoAdjunto])

    useEffect(()=>{
       setIsPopoverOpen(false);
    },[tipoAdjunto])


    const onButtonClick = () =>
        setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    const iconTypeItem = useMemo(()=> { return tipoAdjunto&&TIPOSADJUNTO.filter((f)=> f.tag===tipoAdjunto.tag)[0]}, [tipoAdjunto])
    const button = ()=>(<EuiButtonIcon className='btnTipoAdjunto' title={tipoAdjunto.descripcion} iconType={iconTypeItem&&iconTypeItem.icon}  onClick={(e)=>{changeType && onButtonClick()}}/>)

    // const getLabelItem = () =>{
    //     return (<EuiText title={item.file!==undefined ? item.file.name : item.name} onClick={()=>{onDonwLoad&&onDonwLoad(item.id,item.file.name)}}>
    //         {item.file!==undefined ? item.file.name : item.name}
    //     </EuiText>)
    // }

    const getLabelItem = () =>{
        return (
         <EuiFlexGroup> 
            <EuiFlexItem>
                <EuiText   onClick={()=>{onDonwLoad&&onDonwLoad(item.id,item.file.name)}}>
                    {item.file!==undefined ? item.file.name : item.name}
                </EuiText>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                {`${item.file!==undefined ? toDecimalString((item.file.size/1024)/1024) : toDecimalString(0)}MB`}
            </EuiFlexItem>
        </EuiFlexGroup>  
        )
    }

    const pop= () =>(<EuiPopover
    ownFocus={false}
    button={button()}
    isOpen={isPopoverOpen}
    anchorPosition='upCenter'
    closePopover={closePopover}
    >
    <TiposAdjuntoList onSelect={setTipoAdjunto}/>
    </EuiPopover>)
    
    return item && (
        <EuiListGroupItem
        id={item.file!==undefined ? item.file.name : item.name}
        className='item-adjuntos'
        icon={pop()}
        label={getLabelItem()}
        onClick={()=>{}}
        isActive
        extraAction={(extraAction && extraAction(item.id ? item.id : (item.file!==undefined ? item.file : item)))}
        />
    )
}